import { get } from "lodash-es";

const JAPAN_STYLE_VALUES = new Set([
  "japan",
  "jp",
  "japanese",
  "japanstyle",
  "japan-style",
  "日本",
  "日本风格",
  "日本風格",
  "日式",
  "日系",
]);

function normalizeShopStyleValue(value) {
  if (value === null || typeof value === "undefined") {
    return "";
  }

  return String(value).trim().toLowerCase().replace(/\s+/g, "");
}

function pickFirstMeaningfulValue(values = []) {
  return values.find((item) => item !== null && typeof item !== "undefined" && String(item).trim() !== "");
}

function parseConfigData(configData) {
  if (!configData) {
    return {};
  }

  if (typeof configData === "string") {
    try {
      return JSON.parse(configData);
    } catch (error) {
      return {};
    }
  }

  return configData;
}

export function resolveShopStyle(storeInfo = {}) {
  const parsedConfigData = parseConfigData(get(storeInfo, "configData"));

  const configStyle = pickFirstMeaningfulValue([
    get(parsedConfigData, "shopStyle"),
    get(parsedConfigData, "storeStyle"),
    get(parsedConfigData, "themeStyle"),
    get(storeInfo, "shopStyle"),
    get(storeInfo, "storeStyle"),
    get(storeInfo, "themeStyle"),
    get(storeInfo, "style"),
    get(storeInfo, "appSetting.shopManage.shopStyle"),
    get(storeInfo, "appSetting.shopManage.storeStyle"),
    get(storeInfo, "shopManage.shopStyle"),
    get(storeInfo, "shopManage.storeStyle"),
  ]);

  return {
    raw: configStyle || "",
    normalized: normalizeShopStyleValue(configStyle),
  };
}

export function isJapanShopStyle(storeInfo = {}) {
  const { normalized } = resolveShopStyle(storeInfo);
  return JAPAN_STYLE_VALUES.has(normalized);
}
